import { render } from "./ModalHolder.vue?vue&type=template&id=24ff5398&scoped=true&ts=true&lang=pug"
import script from "./ModalHolder.vue?vue&type=script&lang=ts"
export * from "./ModalHolder.vue?vue&type=script&lang=ts"

import "./ModalHolder.vue?vue&type=style&index=0&id=24ff5398&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ff5398"]])

export default __exports__